var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.474684 0.558058C0.718762 0.313981 1.11449 0.313981 1.35857 0.558058L6.35857 5.55806C6.60265 5.80214 6.60265 6.19786 6.35857 6.44194L1.35857 11.4419C1.11449 11.686 0.718762 11.686 0.474684 11.4419C0.230607 11.1979 0.230607 10.8021 0.474684 10.5581L5.03274 6L0.474684 1.44194C0.230607 1.19786 0.230607 0.802136 0.474684 0.558058Z",
    fill: "#3E3E53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBlack);
export default __webpack_public_path__ + "static/media/right_arrow_black.4647d3fe6c3fe7a03a260725291b18bb.svg";
export { ForwardRef as ReactComponent };